/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'underscore';
import { Storage } from '@bingads-webui/window-name-store';
import PropTypes from 'prop-types';

const rcidKey = 'rcid';

export const TreeViewWithRCIDStorage = WrappedComponent =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        rootCustomerId: this.props.rootCustomerId,
      };
    }

    componentDidMount() {
      if (this.props.useStorageForRCID) {
        const storage = new Storage();
        const rcid = storage.get(rcidKey);

        // In CCUI, rcid is a string while in CMUI, rcid is a number.
        // To adapt to both types, we use rcid >= 0 to verify if rcid is valid or not.
        if (_.isNull(rcid) || !(rcid >= 0) || rcid === this.state.rootCustomerId) {
          storage.set(rcidKey, this.state.rootCustomerId);
        } else {
          // Verify this root customer id works with the current customer id
          this.props.ccCustomerService.getAncestorHierarchyPath({
            cid: rcid,
            uid: this.props.userId,
            entityId: this.props.selectedEntity.id,
            isCustomer: this.props.selectedEntity.isCustomer,
          }).then((data) => {
            if (data.parentCustomerEntities.length > 0) {
              this.setState({
                rootCustomerId: rcid,
              });
            }
          }).finally(() => {
            storage.set(rcidKey, this.state.rootCustomerId);
          });
        }
      }
    }

    render() {
      return (<WrappedComponent {...this.props} rootCustomerId={this.state.rootCustomerId} />);
    }
  };

TreeViewWithRCIDStorage.propTypes = {
  /**
   * Determines if the stored rcid should be used
  */
  useStorageForRCID: PropTypes.bool.isRequired,
  /**
   * Client Center Customer Service to fetch ancestor hierarchy path
  */
  ccCustomerService: PropTypes.shape({
    getAncestorHierarchyPath: PropTypes.func.isRequired,
  }).isRequired,
  /**
   * root customer id or the login user's parent customer id
  */
  rootCustomerId: PropTypes.number.isRequired,
  /**
   * selected account/ customer entity id
   */
  selectedEntity: PropTypes.shape({
    id: PropTypes.number.isRequired,
    isCustomer: PropTypes.bool.isRequired,
  }).isRequired,
  /**
   * user id of the current user context
  */
  userId: PropTypes.number.isRequired,
};
